export default {
  title: "library",
  selectedItem: null,
};
